// extracted by mini-css-extract-plugin
export default {"text_input":"SelectBox_text_input__Ox965","input_box":"SelectBox_input_box__KfXSu"};